<template>
  <el-cascader
    v-model="value"
    :options="options"
    placeholder="请选择群组"
    :props="propsSetting"
    clearable
    @change="handleChange"
  />
</template>

<script>
export default {
  name: 'SpSearchGroup',
  props: {
    clearValue: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: '',
      options: [],
      propsSetting: {
        checkStrictly: true,
        value: 'group_code',
        label: 'group_name',
        children: 'children'
      }
    }
  },
  watch: {
    clearValue (val) {
      console.log('999', val)
      if (val) {
        this.value = ''
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取群组列表
    async getList () {
      const data = await this.$api.organization.getGroupsList()
      if (data) {
        this.options = data.list
      }
    },
    handleChange (value) {
      console.log(value)
      this.$emit('changeGroup', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
